import { gql } from '__generated__'

export const GET_GUEST_SESSION = gql(`
  query getGuestSession {
    getGuestSession {
      id
      isBot
      userId
      claimedAt
      expiresAt
    }
  }
`)
